import { apiResourceUrl } from "@ploy-lib/core";
import { BaseResource } from "./BaseResource";
class ObjectVehicleDetails {
    constructor() {
        this.carMake = undefined;
        this.carModel = undefined;
        this.carEngine = undefined;
        this.yearModel = undefined;
        this.regNr = undefined;
    }
}
class FinancialDetails {
    constructor() {
        this.listPrice = undefined;
        this.carPrice = undefined;
        this.equity = undefined;
        this.equityPercent = undefined;
        this.loanAmount = undefined;
        this.loanType = undefined;
        this.termsTotal = undefined;
        this.termLengthType = undefined;
        this.totalMonths = undefined;
        this.totalYears = undefined;
        this.interestOnlyMonths = undefined;
    }
}
class RatesAndFeesDetails {
    constructor() {
        this.netTotalTermAmount = undefined;
        this.nominalInterestRate = undefined;
        this.actualInterestRate = undefined;
        this.establishmentFee = undefined;
        this.documentFee = undefined;
        this.termFee = undefined;
    }
}
class CustomerDetails {
    constructor() {
        this.commentFromCustomer = undefined;
        this.householdStatus = undefined;
        this.shouldSplitLoan = undefined;
    }
}
class PropertyDetails {
    constructor() {
        this.estimatedValue = undefined;
        this.jointDebt = undefined;
        this.useType = undefined;
        this.applicationPropertyId = undefined;
        this.areaScore = undefined;
        this.municipalityScore = undefined;
        this.estimateUncertaintyLevel = undefined;
    }
}
class DebtDetails {
    constructor() {
        this.loanType = undefined;
        this.amount = undefined;
        this.customNumber = undefined;
        this.applicationDebtId = undefined;
    }
}
class LoanType {
    constructor() {
        this.key = undefined;
        this.value = undefined;
    }
}
export class FinancingInformationResource extends BaseResource {
    constructor() {
        super(...arguments);
        this.applicationId = undefined;
        this.objectType = undefined;
        this.carType = undefined;
        this.carObjectData = undefined;
        this.mainCustomerFinancialData = undefined;
        this.coSignerFinancialData = undefined;
        this.splitLoan = false;
        this.ratesAndFeesData = undefined;
        this.customerData = undefined;
        this.propertyData = undefined;
        this.debtData = undefined;
        this.loanTypeData = undefined;
    }
    pk(parent, key) {
        return `${this.applicationId?.toString()}`;
    }
    static url(urlParams) {
        const { applicationId, ...searchParams } = urlParams;
        const url = super.url(urlParams);
        return `${url}`;
    }
}
FinancingInformationResource.urlRoot = apiResourceUrl("financing-information");
//# sourceMappingURL=FinancingInformationResource.js.map